import { createSlice } from '@reduxjs/toolkit';
import { resetApplication } from '../application/slice';
import mapboxState from './state';
export const mapboxSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => mapboxState);
    },
    initialState: mapboxState,
    name: 'mapbox',
    reducers: {
        errorReceiveMapFeatureSources: state => {
            state.mapFeatureSources = undefined;
            state.requestingMapFeatureSources = false;
        },
        failedReceiveMapFeatureSources: state => {
            state.mapFeatureSources = undefined;
            state.requestingMapFeatureSources = false;
        },
        receiveMapFeatureSources: {
            prepare: mapFeatureSources => {
                return {
                    payload: {
                        mapFeatureSources
                    }
                };
            },
            reducer: (state, action) => {
                const { mapFeatureSources } = action.payload;
                state.mapFeatureSources = mapFeatureSources;
                state.requestingMapFeatureSources = false;
            }
        },
        requestMapFeatureSources: state => {
            state.requestingMapFeatureSources = true;
        },
        resetMapbox: () => mapboxState,
        setAws: state => {
            state.aws = true;
        },
        setAzure: state => {
            state.azure = true;
        },
        setDisplayedLocations: {
            prepare: displayedLocations => {
                return {
                    payload: {
                        displayedLocations
                    }
                };
            },
            reducer: (state, action) => {
                const { displayedLocations } = action.payload;
                state.displayedLocations = displayedLocations;
            }
        },
        setGoogle: state => {
            state.google = true;
        },
        setMapStyle: {
            prepare: style => {
                return {
                    payload: {
                        style
                    }
                };
            },
            reducer: (state, action) => {
                const { style } = action.payload;
                state.style = style;
            }
        },
        setPreviewFile: {
            prepare: previewFile => {
                return {
                    payload: {
                        previewFile
                    }
                };
            },
            reducer: (state, action) => {
                const { previewFile } = action.payload;
                state.previewFile = previewFile;
            }
        },
        unsetAws: state => {
            state.aws = false;
        },
        unsetAzure: state => {
            state.azure = false;
        },
        unsetDisplayedLocations: state => {
            state.displayedLocations = undefined;
        },
        unsetGoogle: state => {
            state.google = false;
        }
    }
});
export const { errorReceiveMapFeatureSources, failedReceiveMapFeatureSources, receiveMapFeatureSources, requestMapFeatureSources, resetMapbox, setAws, setAzure, setDisplayedLocations, setGoogle, setMapStyle, setPreviewFile, unsetAws, unsetAzure, unsetDisplayedLocations, unsetGoogle } = mapboxSlice.actions;
export default mapboxSlice.reducer;
